import { Button, Container, Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import styles from '../style.module.scss';

const AwardsComponent = () => {
  return (
    <Container maxWidth="lg" className="mt-5">
      <div className={styles.InfoDiv}>
        <Grid container spacing={2}>
          <Grid item md={6} xl={6} lg={6} sm={12} xs={12}>
            <h2 className={styles.secondaryText}>Awards & Accolades</h2>
          </Grid>
          <Grid item md={2} xl={2} lg={2} sm={12} xs={12}>
            <div className={styles.awardContainer}>
              <img
                alt="arzooo-header-logo"
                className={styles.headerLogo}
                src="/images/awards1.svg"
              ></img>
            </div>
          </Grid>
          <Grid item md={2} xl={2} lg={2} sm={12} xs={12}>
            <div className={styles.awardContainer}>
              <img
                alt="arzooo-header-logo"
                className={styles.headerLogo}
                src="/images/awards2.svg"
              ></img>
            </div>
          </Grid>
          <Grid item md={2} xl={2} lg={2} sm={12} xs={12}>
            <div className={styles.awardContainer}>
              <img
                alt="arzooo-header-logo"
                className={styles.headerLogo}
                src="/images/awards3.svg"
              ></img>
            </div>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
};
export default AwardsComponent;
